export enum UserQueryKeysEnum {
  USER_DETAILS_STATE = 'userDetailsState',
  USERS_STATE = 'usersState',
}
